import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoutButton from "../../auth/LogoutButton";
import { Button } from "../atoms/button";
import { useAuth } from "../../auth/AuthContext";

export const ConditionalNavbar = () => {
  const location = useLocation();
  const showNavbarOnRoutes = ["/", "/onboarding", "/recording"]; // Add or remove routes as needed
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [allowEditPayment, setAllowEditPayment] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth() as any;

  useEffect(() => {
    if (location?.pathname && showNavbarOnRoutes.includes(location.pathname)) {
      async function verifyUserPaymentInfo() {
        if (user?.email) {
          const apiUrl = process.env.REACT_APP_API_URL;
          const getUserUrl = `${apiUrl}/users/${user.email}/`;
          const response = await fetch(getUserUrl, {
            method: "GET",
            headers: {
              Authorization: `bearer ${user?.accessToken}`,
            },
          });

          if (!response.ok) {
            navigate("/signup");
          }

          const userData = await response.json();

          if (!userData.is_internal) {
            setAllowEditPayment(true);
          }
        }
      }
      verifyUserPaymentInfo().then();
    }
  }, [location]);

  if (!showNavbarOnRoutes.includes(location.pathname)) {
    return null; // Don't render navbar on other routes
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="p-4 bg-gray-200">
      <div className="container mx-auto flex items-center justify-between">
        {/* Logo or Branding - can be added here if needed */}
        <span className="text-xl font-semibold">Perle Collect</span>

        {/* Hamburger Button */}
        <button
          onClick={toggleMobileMenu}
          className="text-gray-700 md:hidden focus:outline-none" // md:hidden hides it on medium screens and up
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={
                isMobileMenuOpen
                  ? "M6 18L18 6M6 6l12 12"
                  : "M4 6h16M4 12h16M4 18h16"
              }
            ></path>
          </svg>
        </button>

        {/* Desktop Menu (visible on medium screens and up) */}
        <ul className="hidden md:flex space-x-4 items-center">
          <li>
            <Button type="primary" onClick={() => navigate("/history")}>
              Go to submission history
            </Button>
          </li>
          {allowEditPayment && (
            <li>
              <Button type="primary" onClick={() => navigate("/payment-edit")}>
                Edit payment information
              </Button>
            </li>
          )}
          <li>
            <LogoutButton />
          </li>
        </ul>
      </div>

      {/* Mobile Menu (conditionally rendered) */}
      {isMobileMenuOpen && (
        <div className="md:hidden mt-2">
          {" "}
          <ul className="flex flex-col space-y-2">
            <li>
              <Button type="primary" onClick={() => navigate("/history")}>
                Go to submission history
              </Button>
            </li>
            {allowEditPayment && (
              <li>
                <Button
                  type="primary"
                  onClick={() => navigate("/payment-edit")}
                >
                  Edit payment information
                </Button>
              </li>
            )}
            <li className="pt-2">
              <LogoutButton />
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};
